import { Component, Inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [
    MatDialogModule,
    MatButton
  ],
  selector: 'equine-ui-nx-remove-from-cart-dialog',
  templateUrl: './remove-from-cart-dialog.component.html',
  styleUrls: ['./remove-from-cart-dialog.component.scss']
})
export class RemoveFromCartDialogComponent implements OnInit {

  itemsLength = 0;
  nonRemovableItems = false;

  constructor(
    public dialogRef: MatDialogRef<RemoveFromCartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {orderId: string, items: any[], nonRemovableItems: boolean}
  ) {}

  ngOnInit() {
    this.itemsLength = this.data.items.length;
    this.nonRemovableItems = this.data.nonRemovableItems;
  }

  remove() {
    this.dialogRef.close(this.data.orderId);
    console.log(this.data.orderId)
  }

}
